import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Case } from '../../../../shared/api/hscan/case';
import { Spacer } from '../../common/components/Spacer';
import { WideModal } from '../../common/components/WideModal';

import { PaymentSection } from './PaymentSection';
import { RequestImageSection } from './RequestImageSection';

const Title = styled.div`
  font-size: 40px;
  font-weight: bold;
`;

interface RequestCdModalProps {
  open: boolean;
  onClose: () => void;
  cases: Case[];
}
export const RequestCdModal = ({
  open,
  onClose,
  cases,
}: RequestCdModalProps) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.imageList.cd',
  });
  const caseIds = useMemo(() => cases.map(c => c.caseId), [cases]);

  return (
    <WideModal open={open} onClose={onClose} width="1200px">
      <Title>{t('title')}</Title>
      <Spacer height="40px" />
      <RequestImageSection cases={cases} />
      <Spacer height="30px" />
      <PaymentSection caseIds={caseIds} onClose={onClose} />
    </WideModal>
  );
};
